var timelineAgent;
const timelineTimeState = new Map();

const getType = (item) => {
  if (item.value === '1') {
    return `${item.value}st ${item.type}`;
  } else if (item.value === '2') {
    return `${item.value}nd ${item.type}`;
  } else {
    return `${item.value}th ${item.type}`;
  }
}

const getTypeWithIcon = (item, side) => {
  const icon = `<span class="SoccerSummaryRow_Icon ${item.type.replaceAll(' ', '-')}"></span>`
  if (side === 'left') {
    return getType(item) + ' ' + icon;
  }
  return icon + ' ' + getType(item);
}

const parseTimelineMinute = (minute) => {
  if (minute === null || minute === undefined) {
    return 0;
  }

  const [minutesPart = '0', secondsPart = '0'] = `${minute}`.split(':');
  const minutes = parseInt(minutesPart, 10);
  const seconds = parseInt(secondsPart, 10);

  return (Number.isNaN(minutes) ? 0 : minutes) + (Number.isNaN(seconds) ? 0 : seconds / 60);
}

const formatTimelineMinute = (minute) => {
  const totalSeconds = Math.max(0, Math.round(parseTimelineMinute(minute) * 60));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

const getTimelineState = (game_api_id, fallbackTime) => {
  const storedState = timelineTimeState.get(String(game_api_id)) || {};
  const currentTime = storedState.currentTime || fallbackTime || '0';
  const currentTimeValue = parseTimelineMinute(currentTime);
  const totalTime = currentTimeValue > 90 ? 120 : 90;

  return {
    currentTime,
    currentTimeValue,
    currentTimeString: formatTimelineMinute(currentTime),
    totalTime,
  };
}

const applyTimelineStateToDom = (game_api_id, state) => {
  const timelineElement = document.querySelector(`.timeline[game-api-id="${game_api_id}"]`);

  if (!timelineElement) {
    return;
  }

  timelineElement.style.setProperty('--timeline-current-time', state.currentTimeValue);
  timelineElement.style.setProperty('--timeline-total-time', state.totalTime);
  timelineElement.style.setProperty('--timeline-current-time-string', `"${state.currentTimeString}"`);
}

const getTimelineIconType = (type) => {
  const normalizedType = `${type ?? ''}`.toLowerCase();

  if (normalizedType === 'own goal' || normalizedType === 'owngoal') {
    return 'OwnGoal';
  }

  if (normalizedType === 'yellow card' || normalizedType === 'yellow-card') {
    return 'Yellow-card';
  }

  if (normalizedType === 'red card' || normalizedType === 'red-card') {
    return 'Red-card';
  }

  return `${type ?? ''}`.replace(/\s+/g, '-');
}

const getProgressBar = (items, currentTime) => {
  const allowedTypes = new Set(['goal', 'owngoal', 'own goal', 'yellow card', 'yellow-card', 'red card', 'red-card']);
  const relevantItems = (Array.isArray(items) ? items : []).filter((item) => {
    const normalizedType = `${item?.type ?? ''}`.toLowerCase();
    return allowedTypes.has(normalizedType);
  });

  const derivedCurrentTime = currentTime || (Array.isArray(items) && items.length ? items.reduce((latest, item) => {
    const itemMinute = parseTimelineMinute(item?.minute);
    return itemMinute > latest ? itemMinute : latest;
  }, 0) : 0) || 90;

  const currentTimeValue = parseTimelineMinute(derivedCurrentTime);
  const totalMinutes = currentTimeValue > 90 ? 120 : 90;

  const events = relevantItems.map((item) => {
    const eventTimeValue = parseTimelineMinute(item?.minute);
    const iconType = getTimelineIconType(item?.type);
    const teamOffset = item?.team === '1' ? '-3px' : item?.team === '2' ? '3px' : '0px';

    return /*html*/`
      <span class="timeline-progress-bar__event" style="--timeline-event-time: ${eventTimeValue}; --timeline-event-offset: ${teamOffset};">
        <span class="SoccerSummaryRow_Icon ${iconType}"></span>
      </span>`;
  }).join('');

  return /*html*/`
    <div class="timeline-progress-bar" style="--timeline-current-time: ${currentTimeValue}; --timeline-total-time: ${totalMinutes}; --timeline-current-time-string: \"${formatTimelineMinute(derivedCurrentTime)}\";">
      <div class="timeline-progress-bar__track">
        <div class="timeline-progress-bar__fill"></div>
        <div class="timeline-progress-bar__events">${events}</div>
        <div class="timeline-progress-bar__current-time">${formatTimelineMinute(derivedCurrentTime)}</div>
      </div>
    </div>`;
}

let Timeline = {
  render: async (game_api_id, live) => {
    if(!game_api_id) {
      return '';
    }
    let view =  /*html*/`<div class="timeline ${live ? 'live' : ''}" game-api-id="${game_api_id}"></div>`
    return view
  },
  after_render: async (game_api_id) => {
    refreshTimeline(game_api_id);

    if(timelineAgent) {
      clearInterval(timelineAgent);
    }
    timelineAgent = setInterval(() => {
      var $view = $('#timeline-view');
      if(!$view) {
        clearInterval(timelineAgent);
        return;
      }

      Timeline.refreshTimeline();
    }, 3000);
  },
  on_unload: () => {
    if(timelineAgent) {
      clearInterval(timelineAgent);
    }
  },
  updateTime(game_api_id, time) {
    const state = {
      currentTime: time,
      currentTimeValue: parseTimelineMinute(time),
      currentTimeString: formatTimelineMinute(time),
      totalTime: parseTimelineMinute(time) > 90 ? 120 : 90,
    };

    timelineTimeState.set(String(game_api_id), state);
    applyTimelineStateToDom(game_api_id, state);
    Timeline.refreshTimeline(game_api_id);
  },
  getTimelineForGame(game_api_id) {
    return new Promise((resolve, reject) => {
      $.getJSON(`${window.location.origin}/games-timeline/${game_api_id}.json`, function( items ) {
        if(!items || !Array.isArray(items)) {
          reject('No data available');
          return;
        }
    
        let view = '';

        items = items.filter(i => i.type_id !== '40'); // filter out VAR events
        const timelineState = getTimelineState(game_api_id, items.length ? items.reduce((latest, item) => {
          const itemMinute = parseTimelineMinute(item?.minute);
          return itemMinute > latest ? itemMinute : latest;
        }, 0) : '0');
        applyTimelineStateToDom(game_api_id, timelineState);

        items.reverse().forEach(item => {
          if(item.team !== '0') {
            view += `
            <div class="timeline-row">
              <div>${item.team == '1' ? (getTypeWithIcon(item, 'left'))  : ''}</div>
              <div>${item.minute.split(':')[0]}'</div>
              <div>${item.team == '2' ? (getTypeWithIcon(item, 'right')) : ''}</div>
            </div>`;
          } else {
            view += `<div class="timeline-row-full">${item.type} ${item.minute}</div>`;
          }
        });

        const progressBar = getProgressBar(items, timelineState.currentTime);
        view = `${progressBar}${view}`;
        
        resolve(view);
      }, function() {
        reject('No data available');
      }).fail(function() {
        resolve('<div style="text-align: center; color: #ffffff">No data available<div>');
      });
    });
  },
  refreshTimeline(id) {
    refreshTimeline(id);
  }
}

function refreshTimeline(id) {
  var $view = $(id ? `.timeline[game-api-id=${id}]` : '.timeline.live')
  if(!$view) {
    return;
  }

  $view.each(async function(index) {
    var game_api_id = $(this).attr('game-api-id');
    var content = await Timeline.getTimelineForGame(game_api_id);
    $(this).html(content);
  });
}

export default Timeline;
